// components/AlumniSpeak.js
'use client'
import { FadeIn } from '@/components/ui/animation/faideIn'

import { buttonVariants } from '@/components/ui/button'
import { SvgArrowUpRight } from '@/components/ui/icons'
import apolloClient from '@/lib/apollo/apollo-client'
import { MEDIAPOST } from '@/lib/apollo/queries'
import { cn } from '@/lib/utils/helpers'
import { cache, useEffect, useRef, useState } from 'react'
import MdTestimonialCard from './MdTestimonialCard'
import SmTestimonialCard from './SmTestimonialCard'

import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Fragment } from 'react'
import ReactPlayer from 'react-player'

const AlumniSpeak = () => {
  const [mediaPosts, setMediaPosts] = useState(null)
  const [open, setOpen] = useState(false)
  const [isLodaing, setIsLoading] = useState(false)

  const getData = cache(async () => {
    setIsLoading(true)
    try {
      const useCasesOptions = await apolloClient.query({
        query: MEDIAPOST,
      })

      // console.log('useCasesData', useCasesOptions)
      const useCasesData = useCasesOptions.data.mediaPosts?.nodes

      const mappedArray = useCasesData
        .filter((r) => r?.mediaPostType?.videoUrl)
        .map((val, index) => {
          let obj = {
            src: val.featuredImage?.node.sourceUrl,
            videoUrl: val.mediaPostType.videoUrl,
            categories: val.categories.nodes,
            title: val.title,
            categories: val.categories.nodes,
            height: `${200 + Math.floor(Math.random() * 200)}px`,
          }
          return obj
        })
      //  console.log(mappedArray)
      setMediaPosts(mappedArray)
      // setFilteredVals(mappedArray)
    } catch (error) {
      console.error('Failed to fetch events', error)
    }
    setIsLoading(false)
  })
  useEffect(() => {
    getData()
  }, [])
  return (
    <div className="pt-24 w-full max-w-7xl px-6 lg:px-8 mx-auto">
      <div>
        <div className="w-full justify-between md:items-end gap-5 flex-col md:flex-row inline-flex">
          <div className="w-full  flex-col justify-start items-start gap-5 inline-flex  ">
            <div className="self-stretch flex-col justify-start items-start gap-3 flex w-full ">
              <div className="flex justify-between w-full items-center">
                <FadeIn className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
                  <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                    <div className="text-center text-white text-sm font-medium leading-[20px]">
                      Alumni Speak
                    </div>
                  </div>
                </FadeIn>
                <FadeIn>
                  <div
                    onClick={() => setOpen(true)}
                    className={cn(
                      buttonVariants({ variant: 'outline', size: 'lg' }),
                      'text-base cursor-pointer',
                    )}
                  >
                    View all videos <SvgArrowUpRight className="ml-2 w-5 h-5" />
                  </div>
                </FadeIn>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-between w-full">
                <FadeIn className=" text-white text-[48px] font-semibold w-[-webkit-fill-available]  ">
                  Hear from our current Founders
                </FadeIn>
                <FadeIn className=" text-[#D0D5DD] text-lg font-normal w-[-webkit-fill-available] ">
                  Insights and reflections from the trailblazers who shaped
                  their futures with AI Forge
                </FadeIn>
              </div>
            </div>
          </div>
        </div>
        <FadeIn>
          {mediaPosts && mediaPosts?.length === 0 ? (
            <h1 className="text-center gap-2 mt-10 px-6 lg:px-8 max-w-7xl mx-auto  text-white">
              No results found
            </h1>
          ) : (
            <TestimonialsSection mediaPosts={mediaPosts} />
          )}
        </FadeIn>
        {open && (
          <VideosModal
            mediaPosts={mediaPosts}
            open={open}
            setOpen={setOpen}
            onClose={() => {
              setOpen(false)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default AlumniSpeak

function TestimonialsSection({ mediaPosts }) {
  const [selectedTestimonialIndex, setSelectedTestimonialIndex] = useState(0)
  const [measuredWidth, setMeasuredWidth] = useState(null)
  const contentRef = useRef(null)

  const toggleTestimonial = (index) => {
    setSelectedTestimonialIndex((prev) => (prev === index ? null : index))
  }

  useEffect(() => {
    if (contentRef?.current?.offsetWidth) {
      setMeasuredWidth(contentRef.current.offsetWidth - 710)
    }
  }, [])

  return (
    <div className="relative">
      <div
        ref={contentRef}
        className="hidden lg:flex items-stretch space-x-8 justify-center my-16"
      >
        {measuredWidth &&
          mediaPosts
            ?.filter((val) => val.title !== 'The AI Forge Summer Beach Party')
            ?.slice(0, 4)
            ?.reverse()
            .map((testimonial, index) => {
              return (
                <MdTestimonialCard
                  key={`testimonial_${index}`}
                  testimonial={testimonial}
                  index={index}
                  selectedTestimonialIndex={selectedTestimonialIndex}
                  toggleTestimonial={toggleTestimonial}
                />
              )
            })}
      </div>

      <div className="lg:hidden flex flex-col space-y-4 my-6">
        {mediaPosts
          ?.filter((val) => val.title !== 'The AI Forge Summer Beach Party')
          ?.slice(0, 4)
          ?.reverse()
          ?.map((testimonial, index) => {
            return (
              <SmTestimonialCard
                key={`testimonial_${index}`}
                testimonial={testimonial}
                index={index}
                selectedTestimonialIndex={selectedTestimonialIndex}
                toggleTestimonial={toggleTestimonial}
              />
            )
          })}
      </div>
    </div>
  )
}
function VideosModal({ open, setOpen, onClose, mediaPosts }) {
  return (
    <Transition.Root show={open ? true : false} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 w-auto sm:w-screen overflow-y-auto">
          <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`px-6 py-5 bg-[#191b20] 
                rounded-[10px] border border-zinc-900 flex-col sm:min-w-[500px] w-auto `}
              >
                <div className="flex flex-col gap-4 h-full w-full ">
                  <div className="flex justify-between item border-b border-[#414653] pb-4">
                    <h1 className="text-[#98A2B3] text-[22.32px] font-semibold ">
                      All Videos
                    </h1>

                    <XMarkIcon
                      className="h-6 w-6 text-[#98A2B3] cursor-pointer"
                      onClick={() => {
                        setOpen(false)
                      }}
                    />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 justify-center my-4">
                    {mediaPosts.map((testimonial, index) => {
                      return (
                        testimonial?.videoUrl && (
                          <div
                            key={`testimonial_${index}`}
                            className=" w-full h-full overflow-hidden rounded-md "
                          >
                            {!testimonial?.videoUrl?.includes(
                              'drive.google.com',
                            ) ? (
                              <ReactPlayer
                                url={testimonial?.videoUrl}
                                playing={false}
                                className=" rounded !min-h-[300px] !h-[300px] !w-auto"
                                controls={false}
                                loop
                              />
                            ) : (
                              <iframe
                                width="100%"
                                height="300px"
                                allow="autoplay"
                                src={
                                  testimonial?.videoUrl.endsWith('/')
                                    ? `${testimonial?.videoUrl}preview`
                                    : `${testimonial?.videoUrl}/preview`
                                }
                              ></iframe>
                            )}
                          </div>
                        )
                      )
                    })}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
